module.exports = __webpack_public_path__ + "static/media/1999_GDP_totalRate.58b6823d.png";